import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { OverlaysStepperService } from '@fb-tool-front/core/services/overlays-stepper.service';
import { map } from 'rxjs/operators';

@Injectable()
export class OnboardingOverlaysThirdGuard implements CanActivate {
  constructor(private overlaysStepperService: OverlaysStepperService, private router: Router) {}

  canActivate() {
    return this.overlaysStepperService.availableStep$.pipe(
      map(res => {
        if (res <= 1) {
          this.router.navigate(['home-overlays/2']);

          return false;
        }

        return true;
      })
    );
  }
}
